<template>
  <div
    v-for="item in getTokenAmounts(props.pool)"
    :key="item"
    class="pool-balance"
  >
    {{ item }}
  </div>
</template>
<script lang="ts" setup>
import { getTokenAmounts } from '@/composables/usePoolsTableServices';
import { IPersistedPoolV1, IPersistedTokenExtended } from '@/types/pools';

interface IProps {
  pool: IPersistedPoolV1 & {
    tokenEntities: {
      fromTokenEntity: IPersistedTokenExtended;
      toTokenEntity: IPersistedTokenExtended;
    };
  };
}

const props = defineProps<IProps>();
</script>
